import {
  FETCH_PROJECTS,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_ERROR,
  SET_PROJECT
} from '../actions';
import { normalize, schema } from 'normalizr';

const project = new schema.Entity('project');

const INIT_STATE = {
  fetching: true,
  error: null,
  data: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PROJECTS:
      return {
        ...state,
        fetching: true
      };

    case FETCH_PROJECTS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: normalize(action.payload.data, [ project ])
      };

    case FETCH_PROJECTS_ERROR:
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      };

    case SET_PROJECT:
      const updated_project = action.payload.data;
      return {
        ...state,
        entities: {
          project: {
            ...state.entities.project,
            [project.id]: updated_project
          }
        }
      };

    default:
      return state;
  }
}
